// MP config
export const MAX_MIXPANEL_STRING_CHARS = 255;

// Event Names
export const READING_ORDER_TAB_OPENED = 'Reading Order Tab Opened';
export const VISUAL_SIMULATOR_TAB_OPENED = 'Visual Simulator Tab Opened';
export const ALT_TEXT_MODAL_OPENED = {
  eventName: 'Alt Text Modal Opened',
  from: {
    AltTag: 'Alt Tag',
    AccessibilyChecker: 'Accessibility Checker',
  },
};
export const ALT_TEXT_LABELS_APPLIED = {
  eventName: 'Alt Text Labels Applied',
};
export const ALT_TEXT_EDITED = 'Alt Text Edited';
export const ALT_TEXT_GENERATED = 'Alt Text Generated';
export const ALT_TEXT_GENERATION_ERROR = 'Alt Text Generation Error';
export const HELP_OPENED = 'Help Opened';
export const DOCUMENT_LANGUAGE_MODAL_OPENED = 'Document Language Modal Opened';
export const DOCUMENT_LANGUAGE_EDITED = 'Document Language Edited';
export const TEXT_TAG_EDITED = 'Text Tag Edited';
export const ACCESSIBILITY_CHECKER_OPENED = 'Accessibility Checker Opened';
export const ACCESSIBILITY_AUTO_CHECKED = 'Accessibility Auto Checked';
export const ACCESSIBILITY_MANUAL_CHECKED = 'Accessibility Manual Checked';
export const TABLE_HEADER_EDITED = 'Table Header Edited';
export const IMAGE_UPLOADED = 'Image Uploaded';
export const COLOR_PICKER_CONTRAST_OPENED = 'Color Contrast Opened';
export const TEXT_CREATED = {
  eventName: 'Text Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    KeyboardShortcut: 'Keyboard Shortcut',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const TEXT_COPIED = {
  eventName: 'Text Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const TEXT_DELETED = {
  eventName: 'Text Deleted',
};
export const OPEN_SHARE_MODAL = {
  eventName: 'Open Share Modal',
  from: {
    ShareButton: 'Editor Share Button',
    DownloadButton: 'Editor Download Button',
  },
};
export const TEXT_EDITED = {
  eventName: 'Text Edited',
  styling_property: {
    Font: 'Font Family',
    Effect: 'Effect',
  },
  styling_value: {
    Shadow: 'Shadow',
    Glow: 'Glow',
    Outline: 'Outline',
    Offset: 'Offset',
    Repeat: 'Repeat',
    Thickness: 'Thickness',
    Intensity: 'Intensity',
    Transparency: 'Transparency',
    Direction: 'Direction',
    Blur: 'Blur',
    None: 'None',
  },
};
export const COLOR_EDITED = {
  eventName: 'Color Edited',
  from: {
    ColorPicker: 'Color Picker',
    Hex: 'Hex',
    EyeDropper: 'Eye Dropper',
    Swatch: 'Swatch',
    BrandkitColor: 'Brand Swatch',
  },
};
export const PALETTE_APPLIED = {
  eventName: 'Palette Applied',
  type: {
    Generic: 'Generic',
    BrandKit: 'Brand Kit',
  },
};
export const CANVAS_ZOOM = {
  eventName: 'Canvas Zoom Changed',
  from: {
    ZoomButton: 'Zoom Button',
    KeyboardShortCut: 'Keyboard ShortCut',
    ZoomInput: 'Zoom Input',
  },
};
export const PAGE_SIZE_EDITED = {
  eventName: 'Page Size Edited',
  standardSize: {
    Letter: 'Letter',
    Legal: 'Legal',
    Tabloid: 'Tabloid',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
  },
  displayUnit: {
    Px: 'px',
    Inch: 'in',
    Cm: 'cm',
  },
  magicResize: {
    True: 'True',
    False: 'False',
  },
};
export const PAGE_DELETED = {
  eventName: 'Page Deleted',
};
export const BACKGROUND_FILL_EDITED = {
  eventName: 'Background Fill Edited',
  type: {
    Solid: 'solid',
    Gradient: 'gradient',
  },
};

export const GRADIENT_EDITED = {
  eventName: 'Gradient Edited',
  styling_property: {
    GradientType: 'Gradient Type',
  },
  styling_value: {
    Horizontal: 'Horizontal',
    Vertical: 'Vertical',
    Diagonal_1: 'Diagonal_1',
    Diagonal_2: 'Diagonal_2',
    Radial: 'Radial',
  },
};

export const PATTERN_APPLIED = {
  eventName: 'Pattern Applied',
};
export const PATTERN_REMOVED = {
  eventName: 'Pattern Removed',
};

// Widget Creation and Deletion Events
export const SHAPE_CREATED = {
  eventName: 'Shape Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    Replace: 'Replace',
    KeyboardShortcut: 'Keyboard Shortcut',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
  border: {
    None: 'None',
    Solid: 'Solid',
    Dashed: 'Dashed',
    Dotted: 'Dotted',
  },
};
export const SHAPE_COPIED = {
  eventName: 'Shape Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const SHAPE_REPLACED = {
  eventName: 'Shape Replaced',
};
export const SHAPE_DELETED = { eventName: 'Shape Deleted' };
export const LINE_CREATED = {
  eventName: 'Line Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    KeyboardShortcut: 'Keyboard Shortcut',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
    FlowModePort: 'Flow Mode Port',
  },
  orientation: {
    Horizontal: 'Horizontal',
    Vertical: 'Vertical',
    Diagonal: 'Diagonal',
  },
  lineEdge: {
    None: 'None',
    BasicArrow: 'BasicArrow',
  },
  type: {
    Straight: 'Straight',
    Stepped: 'Stepped',
    Curved: 'Curved',
  },
};
export const LINE_COPIED = {
  eventName: 'Line Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const PORT_NODE_CONNECTED = {
  eventName: 'Port/Node Connected',
};
export const PORT_NODE_DISCONNECTED = {
  eventName: 'Port/Node Disconnected',
};
export const NODE_ADDED = {
  eventName: 'Node Added',
};
export const LINE_DELETED = { eventName: 'Line Deleted' };
export const ICON_CREATED = {
  eventName: 'Icon Created',
  from: {
    Pack: 'Pack',
    Search: 'Search',
    Replace: 'Replace',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const ICON_REPLACED = {
  eventName: 'Icon Replaced',
  category: {
    ReplacedByImage: 'Image',
    ReplacedByIcon: 'Icon',
  },
};
export const ICON_COPIED = {
  eventName: 'Icon Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const ICON_DELETED = { eventName: 'Icon Deleted' };
export const IMAGE_CREATED = {
  eventName: 'Image Created',
  from: {
    Search: 'Search',
    Replace: 'Replace',
    Upload: 'Upload',
    Duplication: 'Duplication',
    Brand: 'Brand Kit',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const IMAGE_COPIED = {
  eventName: 'Image Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const IMAGE_EDITED = {
  eventName: 'Image Edited',
  image_effect: {
    Filter: 'Filter',
    Adjust: 'Adjust',
    ColorOverlay: 'Color Overlay',
    DropShadow: 'Drop Shadow',
    ReturnToOriginal: 'Return to Original',
  },
  color_overlay: {
    Off: 'Off',
    On: 'On',
  },
};
export const IMAGE_REPLACED = {
  eventName: 'Image Replaced',
  category: {
    ReplacedByImage: 'Image',
    ReplacedByIcon: 'Icon',
  },
};
export const IMAGE_DELETED = { eventName: 'Image Deleted' };
export const TABLE_CREATED = {
  eventName: 'Table Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const TABLE_COPIED = {
  eventName: 'Table Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const TABLE_DELETED = { eventName: 'Table Deleted' };
export const CHART_CREATED = {
  eventName: 'Chart Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const CHART_COPIED = {
  eventName: 'Chart Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const CHART_EDITED = {
  eventName: 'Chart Edited',
  styling_property: {
    ChartSwap: 'Chart Swap',
    Labels: 'Labels',
  },
  styling_value: {
    Off: 'Off', // For non axis labels
    On: 'On', // For non axis labels
    XAxisLabelsOn: 'XAxisLabelsOn',
    XAxisLabelsOff: 'XAxisLabelsOff',
    YAxisLabelsOn: 'YAxisLabelsOn',
    YAxisLabelsOff: 'YAxisLabelsOff',
    DataLabelsOn: 'DataLabelsOn',
    DataLabelsOff: 'DataLabelsOff',
  },
  chart_type: {
    Area: 'Area',
    Bar: 'Bar',
    Column: 'Column',
    DonutPie: 'DonutPie',
    HalfPie: 'HalfPie',
    HalfDonutPie: 'HalfDonutPie',
    Histogram: 'Histogram',
    Line: 'Line',
    Pie: 'Pie',
    StackedArea: 'StackedArea',
    StackedBar: 'StackedBar',
    StackedColumn: 'StackedColumn',
    WordCloud: 'WordCloud',
  },
};
export const CHART_DELETED = { eventName: 'Chart Deleted' };
export const WIDGETS_DELETED = { eventName: 'Widgets Deleted' };
export const QR_CODE_DELETED = { eventName: 'QR Code Deleted' };
export const QR_CODE_CREATED = {
  eventName: 'QR Code Created',
  from: {
    LeftPanel: 'Left Panel',
    Duplication: 'Duplication',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};

// MAP WIDGET
export const MAP_CREATED = {
  eventName: 'Map Created',
  from: {
    Duplication: 'Duplication',
    Popular: 'Popular',
    Search: 'Search',
    ContextMenuPaste: 'Context Menu Paste',
    KeyboardPaste: 'Keyboard Paste',
  },
};
export const MAP_COPIED = {
  eventName: 'Map Copied',
  from: {
    ContextMenu: 'Context Menu',
    Keyboard: 'Keyboard',
  },
};
export const MAP_EDITED = {
  eventName: 'Map Edited',
  stylingProperty: {
    ScaleType: 'Scale Type', // Todo: add in scaleType feature
    MapStyle: 'Map Style',
    Labels: 'Labels',
    LabelFormat: 'Label Format',
    Legend: 'Legend',
    AltText: 'Alt Text',
  },
  stylingValue: {
    ScaleTypeGradient: 'Gradient',
    ScaleTypeSteps: 'Steps',
    CustomRangeOn: 'Custom Range On',
    CustomRangeOff: 'Custom Range Off',
    ColorPresets: 'Color Presets',
    NameLabelsOn: 'Name Labels On',
    NameLabelsOff: 'Name Labels Off',
    ValueLabelsOn: 'Value Labels On',
    ValueLabelsOff: 'Value Labels Off',
    LabelFormatName: 'Name',
    LabelFormatValue: 'Value',
    LegendOn: 'On',
    LegendOff: 'Off',
    AltTextDecorative: 'Decorative',
    AltTextEdited: 'Alt Text Edited',
  },
  mapType: {
    ChoroplethSteps: 'Choropleth Steps',
    ChoroplethGradient: 'Choropleth Gradient',
    Bubble: 'Bubble',
    Monochrome: 'Monochrome',
  },
};
export const MAP_DELETED = {
  eventName: 'Map Deleted',
  mapType: {
    ChoroplethSteps: 'Choropleth Steps',
    ChoroplethGradient: 'Choropleth Gradient',
    Bubble: 'Bubble',
    Monochrome: 'Monochrome',
  },
};
export const MAP_IMPORT = {
  eventName: 'Map Imported',
  map_import_status: {
    pass: 'Pass',
    fail: 'Fail',
  },
};
export const AUTO_BRAND_OPENED = {
  eventName: 'Autobrand Opened',
  from: {
    colorMenu: 'Color menu',
    backgroundPanel: 'Background panel',
    brandKitTab: 'Brand kit tab',
    banner: 'Auto-brand banner',
  },
};
export const AUTO_BRAND_ADDED = {
  eventName: 'Autobrand Added',
};
export const AUTO_BRAND_SKIPPED = {
  eventName: 'Autobrand Skipped',
};
export const AUTO_BRAND_DISCARD = {
  eventName: 'Autobrand Discarded',
};
// Critical events
export const DOWNLOAD = 'Download';
export const UPGRADE = {
  eventName: 'Click On Upgrade',
  feature: {
    PrivateShare: 'Private Share',
    FreeShareModal: 'Free Share Modal',
    DownloadButton: 'Download',
    DownloadPremium: 'Download Premium',
    DownloadBusiness: 'Download Business',
    TemplatePremium: 'Editor Template Premium',
    TemplateBusiness: 'Editor Template Business',
    ImageUploadLimit: 'Image Upload Limit',
    HeaderButtonEditor: 'Header Button',
    Brandkit: 'brand kit',
    Style: 'Style',
    BrandkitColor: 'Brand Kit (Colour)',
    BrandkitPalette: 'Brand Kit (Palette)',
    BrandKitLogo: 'Brand Kit (Logo)',
    PremiumChart: 'Premium Chart',
    PremiumMap: 'Premium Map',
    DesignAIGeneration: 'DesignAI Text Generation',
    Share: 'Share',
    Preview: 'Preview',
    Embed: 'Embed',
    SaveAsMyTemplate: 'Save as My Template',
    SaveAsTeamTemplate: 'Save as Team Template',
    InviteTeamMember: 'Invite Member',
  },
};
export const COPY_SHARE_LINK = { eventName: 'Share' };

// Session storage item used for tracking which feature caused upgrade
export const MP_FEATURE_SESSION_STORAGE = 'mixpanel_feature';

// Property Values
export const NAV_BAR = 'Navbar';
export const FILE_MENU = 'File Menu';
export const COLOR_MENU = 'Color Menu';
export const READING_ORDER_MENU = 'Reading Order Menu';
export const ACCESSIBILITY_CHECKER = 'Accessibility Checker';
export const EDITOR_VERSION = 'E2';

export const CHECKER_LABELS = {
  documentLanguage: 'Document Language',
  documentTitle: 'Document Title',
  alternativeText: 'Alternative Text',
  imageTexts: 'Images of Text',
  logicalReadingOrder: 'Logical Reading Order',
  headings: 'Headings',
  colorContrast: 'Color Contrast',
  useOfColor: 'Use of Color',
  links: 'Links',
  tables: 'Tables',
  textSize: 'Text Size',
};

export const ICON_PACK_OPENED = {
  eventName: 'Icon Pack Opened',
};

// Zendesk chat
export const CHAT_OPEN = { eventName: 'Click on Chat Icon' };
export const CHAT_CLOSE = { eventName: 'Hide Chat' };

// Card generator
export const DESIGN_GENERATED = {
  eventName: 'DesignAI Generated',
  templateCategoryName: {
    Cards: 'cards',
    Infographics: 'infographics',
  },
  actionTypeCategoryName: {
    Generate: 'Generate',
    Regenerate: 'Regenerate',
    Retry: 'Retry',
  },
};

export const DESIGN_GENERATED_SUCCESS = {
  eventName: 'DesignAI Generated Success',
};

export const DESIGN_GENERATED_FAIl = {
  eventName: 'DesignAI Generated Fail',
};

// Data import
export const CHART_DATA_IMPORT = {
  eventName: 'Chart Data Imported',
  data_import_status: {
    pass: 'Pass',
    fail: 'Fail',
  },
};

// Share
export const SHARE = { eventName: 'Share' };
export const INVITE_BUTTON = { eventName: 'Click on invite button' };
export const INVITE_MEMBER = { eventName: 'Invite member' };

// Embed
export const EMBED = {
  eventName: 'Embed Code Copied',
  from: 'Editor Top Menu',
  location: 'Embed Panel',
  shareMethod: 'Embed',
};
export const EMBED_TOGGLE = { eventName: 'Embed Feature is Toggled', from: 'Editor Top Menu', location: 'Embed Panel' };

export const ICONS_SEARCH = {
  eventName: 'Icons searched',
};

export const PHOTOS_SEARCH = {
  eventName: 'Photos searched',
};

export const TEMPLATES_SEARCH = {
  eventName: 'Templates searched',
};

export const MAPS_SEARCH = {
  eventName: 'Maps searched',
};

export const TEMPLATES_FILTERED = {
  eventName: 'Editor Templates Filtered',
  filterName: {
    // plan type
    Free: 'Free',
    Premium: 'Premium',
    Business: 'Business',

    // page size
    Letter: 'Letter',
    Custom: 'Custom',
    Square: 'Square',

    // orientation
    Portrait: 'Portrait',
    Landscape: 'Landscape',

    // other
    Accessible: 'Accessible',
  },
};

export const PAGE_NUMBER_ENABLED = { eventName: 'Page Number Enabled' };
export const PAGE_NUMBER_DISABLED = { eventName: 'Page Number Disabled' };

export const PAGE_GUIDE = {
  eventName: 'Page Guide Applied',
  type: {
    Margin: 'Margin',
    Grid: 'Grid',
  },
};

export const DESIGNAI_TEXT_GENERATED = { eventName: 'DesignAI Text Generated' };
export const DESIGNAI_TEXT_GENERATED_ERROR = { eventName: 'DesignAI Text Generation Error' };
export const DESIGNAI_TEXT_GENERATION_STOPPED = { eventName: 'DesignAI Text Generation Stopped' };
export const DESIGNAI_TEXT_GENERATION_DISCARDED = { eventName: 'DesignAi Text Generation Discarded' };
export const DESIGNAI_TEXT_REPLACED = { eventName: 'DesignAI Text Replaced' };
export const DESIGNAI_TEXT_ADDED = { eventName: 'DesignAI Text Added' };
export const DESIGNAI_TEXT_GENERATOR_OPENED = { eventName: 'DesignAI Text Generator Opened' };

export const DESIGNAI_TEXT_UPGRADE = {
  eventName: 'DesignAI Upgrade Clicked',
  from: {
    Modal: 'Upgrade Modal',
  },
};

export const CLICK_GATED_ICON = {
  eventName: 'Click On Paid Icon',
};

export const CLICK_ON_PAID_FEATURE = {
  eventName: 'Click On Paid Feature',
};

// CREATE NEW FROM EDITOR
// Event named passed to E1 backend
export const CREATE_FROM_BLANK = {
  eventName: 'Create Blank From Editor',
};

// Event triggered by frontend
export const CREATE_NEW_DESIGN = {
  eventName: 'Create New from Editor',
  from: {
    Template: 'template',
    Blank: 'blank',
  },
};

/// COPY EVENT
// Event name passed to E1 backend
export const COPY_FROM_EDITOR = {
  eventName: 'Copy From Editor',
};

// Event triggered by frontend
export const SAVE_AS_COPY_FROM_EDITOR = {
  eventName: 'Save as Copy from Editor',
};

export const SCREENSHOT_CAPTURED = { eventName: 'Screenshot Captured' };

export const USER_ACTION = {
  eventName: 'Profile menu clicked',
  from: {
    myDesigns: 'My Designs',
    myAccount: 'My Account',
    signOut: 'Sign Out',
  },
};

export const HELP_LINK = {
  eventName: 'Help menu clicked',
  from: {
    helpCenter: 'Help Center',
    learnTheBasics: 'Learn The Basics',
    keyboardShortcuts: 'Keyboard Shortcuts',
    emailUs: 'Email Us',
    chatWithUs: 'Chat with us',
  },
};

export const DATATABLE_EXPAND = {
  eventName: 'Chart data table expanded',
};

export const DATATABLE_COLLAPSE = {
  eventName: 'Chart data table collapsed',
};

export const PRIVATE_LINK_LOADED = {
  eventName: 'Load Private Link',
};
